import { generateSetChild, generateUpdateOrAddArrayChildren, generateRemoveArrayChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import { config } from '@/config'
import cookie from 'cookie_js'
import { FirebaseGroupOrderService } from '@/service/FirebaseGroupOrderService'
import { format } from '@/utils/format'

let firebaseService = null

export default {
	namespaced: true,
	state: {
		participantToken: null,
		participantId: null,
		participants: [],
		locked: false,
	},
	actions: {
		async addParticipant({ commit, dispatch }, { token, name, accumulatorGroup = null } = {}) {
			const result = await service.addGroupOrderParticipant({ token, name, accumulatorGroup })
			commit('setParticipantToken', { item: result.token })
			cookie.set(config.GROUP_ORDER_PARTICIPANT_COOKIE, result.token, { path: "/" })
			service.defaultHeaders[config.GROUP_ORDER_PARTICIPANT_HEADER] = result.token
			// await dispatch('cart/load', { token }, { root: true })
		},
		async editParticipant({ dispatch }, { token, id, name, accumulatorGroup = null } = {}) {
			const result = await service.editGroupOrderParticipant({ token, id, name, accumulatorGroup })
			if (result.tokenValue) {
				dispatch('cart/readCart', { cart: result }, { root: true })
			}
		},
		async removeParticipant({ dispatch }, { token, id, accumulatorGroup = null } = {}) {
			const result = await service.removeGroupOrderParticipant({ token, id, accumulatorGroup })
			if (result.tokenValue) {
				dispatch('cart/readCart', { cart: result }, { root: true })
			}
		},
		async participantReady({ dispatch }, { token, id, ready, accumulatorGroup = null } = {}) {
			const result = await service.groupOrderParticipantReady({ token, id, ready, accumulatorGroup })
			if (result.tokenValue) {
				dispatch('cart/readCart', { cart: result }, { root: true })
			}
		},
		async restoreParticipant({ commit }) {
			const participant = cookie.get(config.GROUP_ORDER_PARTICIPANT_COOKIE);
			if (participant) {
				commit('setParticipantToken', { item: participant })
				service.defaultHeaders[config.GROUP_ORDER_PARTICIPANT_HEADER] = participant
			}
		},
		async clearGroupOrder({ commit }) {
			commit('setParticipantToken', { item: null })
			cookie.removeSpecific(config.GROUP_ORDER_PARTICIPANT_COOKIE, { path: "/" });
			delete service.defaultHeaders[config.GROUP_ORDER_PARTICIPANT_HEADER]
		},
		setParticipantId({ commit }, { id }) {
			commit('setParticipantId', { item: id })
		},
		setParticipants({ state, commit }, { participants = [] }) {
			commit('updateParticipant', { items: participants })
			state.participants.forEach(participant => {
				if (!participants.find(p => p.id === participant.id)) {
					commit('removeParticipant', { item: participant })
				}
			})
		},
		startFirebaseService({ dispatch, rootGetters }, { firebaseConfig }) {
			if (!firebaseService) {
				firebaseService = new FirebaseGroupOrderService({ firebaseConfig })
				firebaseService.onValue(firebaseService.getRef(`groupOrders/${rootGetters['cart/tokenValue']}`), () => dispatch('cart/load', {}, { root: true }))
			}
		},
		setGroupOrderLock({ commit }, { locked }) {
			commit('setLocked', { item: locked })
		}
	},
	getters: {
		groupOrderParticipant(state) {
			return state.participants.find(p => p.id === state.participantId)
		},
		groupOrderParticipantReady(state, getters) {
			return getters.groupOrderParticipant?.ready ?? false
		},
		groupOrderIsOwner(state, getters) {
			return getters.groupOrderParticipant?.isOwner
		},
		groupOrderParticipantToken(state) {
			return state.participantToken
		},
		groupOrderParticipantId(state) {
			return state.participantId
		},
		groupOrderParticipants(state) {
			return state.participants
		},
		groupOrderJoinUrl(state, getters, rootState, rootGetters) {
			return format(config.HOME_JOIN_ORDER_URL, { basketToken: rootGetters['cart/tokenValue'] })
		},
		groupOrderIsLocked(state) {
			return !!state.locked
		}
	},
	mutations: {
		setParticipantToken: generateSetChild("participantToken"),
		setParticipantId: generateSetChild("participantId"),
		updateParticipant: generateUpdateOrAddArrayChildren("participants"),
		removeParticipant: generateRemoveArrayChild("participants"),
		setLocked: generateSetChild("locked"),
	}
}
